import React from 'react';
import { PatientManualRegistrationParams } from '../PatientManualRegistration';
import useWorkplacePatient, {
	PatientData,
} from '../../../Hooks/useWorkplacePatient';
import { useLazyUserParentsQuery } from '../../../../../graphql/graphql';
import useFilters from '../../../../Base/Hooks/useFilters';
import useHelpers from '../../../../Base/Hooks/useHelpers';
import PatientManualRegistrationSerbiaForm, {
	PatientManualRegistrationSerbiaFormValues,
} from './PatientManualRegistrationSerbiaForm';

interface Props {
	workplaceId: string;
	onSuccess?: (params: PatientManualRegistrationParams) => void;
	setIsLoading: (isLoading: boolean) => void;
}

const PatientManualRegistrationSerbia: React.FC<Props> = ({
	workplaceId,
	onSuccess,
	setIsLoading,
}) => {
	const { createPatient } = useWorkplacePatient();
	const [getParents] = useLazyUserParentsQuery();
	const { handleDateValue } = useFilters();
	const { handleString } = useHelpers();

	const handleSerbiaRegistrationSuccess = async (
		values: PatientManualRegistrationSerbiaFormValues,
	) => {
		setIsLoading(true);
		const data: PatientData = {
			sendEmailInvitation: values.sendPatientInviteToMeddi,
			patient: {
				salutationBefore: values.salutationBefore ?? undefined,
				salutationAfter: values.salutationAfter ?? undefined,
				firstName: values.firstName,
				lastName: values.lastName,
				address: values.address,
				contactPhoneNumber: values.phoneNumber ?? undefined,
				contactEmail: values.email,
				jmbg: values.jmbg,
				birthDate: handleDateValue(values.birthDate),
				citizenship: handleString(values.citizenship?.value),
				gender: handleString(values.gender?.value),
			},
			legalRepresentative: values.legalRepresentative ?? undefined,
			createdByType: handleString(values.createdByType?.value),
			createdById: values.createdById?.item?.user.id ?? undefined,
		};

		const patient: any = await createPatient(data, workplaceId);
		if (patient) {
			let parentId = null;
			if (data.legalRepresentative) {
				const data = await getParents({
					id: patient.data.userId,
				});
				if (data.data?.user?.parents?.[0]?.id) {
					parentId = data.data?.user?.parents?.[0].id;
				}
			}
			onSuccess?.({
				patientId: patient.data.userId,
				parentId: parentId,
				withInvite: data.sendEmailInvitation,
			});
		}
		setIsLoading(false);
	};

	return (
		<PatientManualRegistrationSerbiaForm
			onSuccess={handleSerbiaRegistrationSuccess}
		/>
	);
};

export default PatientManualRegistrationSerbia;
